<template>
  <div id="app" class="mobile">
    <div class="mobile__wrapper phone-wrap" v-if="!homeCheck">
      <div class="top-bar"></div>
      <div class="sleep"></div>
      <div class="volume"></div>
      <div class="screen">
        <section class="view-wrapper">
          <Header v-if="!routeCheck" />
          <transition name="slide">
            <router-view />
          </transition>
          <FooterNav v-if="!routeCheck" />
        </section>
      </div>
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import FooterNav from "./components/FooterNav";

export default {
  name: "App",
  components: {
    Header,
    FooterNav
  },
  computed: {
    routeCheck() {
      if (
        this.$route.path === "/locked/true" ||
        this.$route.path === "/locked/false" ||
        this.$route.path === "/crash"
      ) {
        return true;
      } else {
        return false;
      }
    },
    homeCheck() {
      if (this.$route.path === "/") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap");

:root {
  --black: #161925;
}

body {
  margin: 0;
  height: 100vh;
}

#app {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #2c3e50;
  margin: 0;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  // transition: opacity 0.5s;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
}

.mobile {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  // font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-family: "GM Sans UI";

  @media only screen and (max-width: 1024px) {
    flex-direction: row;
  }

  &__wrapper {
    height: 100%;
    // width: 50vh; // 18x9 portrait
    // width: 43.76vh; //16x9 portrait
    background: #fff;
    margin: 5rem auto;

    display: inline-block;
    position: relative;
    box-sizing: content-box !important;

    .constrain-width & {
      margin: auto;
    }

    @media only screen and (max-width: 600px) {
      margin: 0 auto;
    }
    @media only screen and (max-height: 900px) {
      margin: 2rem auto;
    }

    .screen {
      width: 100%;
      position: relative;
      height: 100%;
      z-index: 0;
      background: #000;
      color: #fff;
      overflow: hidden;
      display: block;
      border-radius: 1px;
      box-shadow: 0 0 0 3px #111;

      @media only screen and (max-width: 600px) {
        width: calc(100% - 4px);
      }
    }

    .top-bar,
    .bottom-bar {
      height: 3px;
      background: black;
      width: 100%;
      display: block;

      @media only screen and (max-width: 600px) {
        display: none;
      }
    }

    .middle-bar {
      width: 3px;
      height: 4px;
      top: 0px;
      left: 90px;
      background: black;
      position: absolute;

      @media only screen and (max-width: 600px) {
        display: none;
      }
    }

    &.phone-wrap {
      padding: 50px 15px 50px 15px;
      width: calc(49vh - 70px);
      height: calc(82vh - 50px);
      background: #dedede;
      border-radius: 20px;

      .constrain-width & {
        // padding: 15px;
        margin: 30px auto;
        width: calc(55vh - 70px);
        // min-width: 500px;
      }

      @media only screen and (max-height: 600px) {
        height: calc(80vh - 50px);
        width: calc(55vh - 70px);
      }

      @media only screen and (max-width: 600px) {
        padding: 0;
        width: 100%;
        height: 100%;
      }

      &:before {
        border-radius: 600px / 50px;
        background: inherit;
        content: "";
        top: 0;
        position: absolute;
        height: 103.1%;
        width: calc(100% - 26px);
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);

        @media only screen and (max-width: 900px) {
          display: none;
        }
      }

      .top-bar {
        width: calc(100% - 8px);
        height: calc(100% - 6px);
        position: absolute;
        top: 3px;
        left: 4px;
        border-radius: 20px;
        background: #fff;

        &:before {
          border-radius: 600px / 50px;
          background: inherit;
          content: "";
          top: 0;
          position: absolute;
          height: 103%;
          width: calc(100% - 26px);
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }

      .bottom-bar {
        display: none;
      }

      .view-wrapper {
        height: 92%;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        &::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background: #000;
        }
      }

      .sleep {
        width: 3px;
        position: absolute;
        left: -3px;
        top: 110px;
        height: 100px;
        background: inherit;
        border-radius: 2px 0px 0px 2px;

        @media only screen and (max-width: 900px) {
          display: none;
        }
      }

      .volume {
        width: 3px;
        position: absolute;
        right: -3px;
        top: 70px;
        height: 45px;
        background: inherit;
        border-radius: 0px 2px 2px 0px;

        @media only screen and (max-width: 900px) {
          display: none;
        }
      }

      .camera {
        background: #3c3d3d;
        width: 10px;
        height: 10px;
        position: absolute;
        top: 18px;
        left: 50%;
        z-index: 3;
        margin-left: -5px;
        border-radius: 100%;

        .constrain-width & {
          display: none;
        }

        @media only screen and (max-width: 900px) {
          display: none;
        }

        &:before {
          background: #3c3d3d;
          width: 6px;
          height: 6px;
          content: "";
          display: block;
          position: absolute;
          top: 2px;
          left: -100px;
          z-index: 3;
          border-radius: 100%;
        }
      }

      &.landscape {
        padding: 15px 50px 15px 50px;
        height: 320px;
        width: 568px;
        margin: auto auto;

        &:before {
          width: 103.1%;
          height: calc(100% - 26px);
          border-radius: 50px / 600px;
        }

        .top-bar {
          left: 3px;
          top: 4px;
          height: calc(100% - 8px);
          width: calc(100% - 6px);

          &:before {
            width: 103%;
            height: calc(100% - 26px);
            border-radius: 50px / 600px;
          }
        }

        .sleep {
          height: 3px;
          width: 100px;
          left: calc(100% - 210px);
          top: -3px;
          border-radius: 2px 2px 0px 0px;
        }

        .volume {
          height: 3px;
          width: 45px;
          right: 70px;
          top: 100%;
          border-radius: 0px 0px 2px 2px;
        }

        .camera {
          top: 50%;
          left: calc(100% - 18px);
          margin-left: 0;
          margin-top: -5px;

          &:before {
            top: -100px;
            left: 2px;
          }
        }
      }
    }
  }
}
</style>
